import React, { Component } from 'react'
import { connect } from 'react-redux'
import { checkForCameraPermissions } from '../utills';
/*
props {
	fileType: 'image/*',
	onChange: 
}
*/

class FileSelector extends Component {

	state = {
		allowMultipleImages: false
	}

	onFileUploadCB = null;

	triggerClick = (allowMultipleImages, dontCheckForCameraPermissions = false) => {
		if(!dontCheckForCameraPermissions) {
			checkForCameraPermissions();
		}
		if(!!allowMultipleImages != this.state.allowMultipleImages){
			this.setState({
				allowMultipleImages
			}, () => {
				this.inputElem && this.inputElem.click()
			})
		} else {
			this.inputElem && this.inputElem.click();
		}
	}
	render() {
		let addInputFileProps = {};
		if(this.state.allowMultipleImages && !this.props.forVideo){
			addInputFileProps = {
				multiple: 'multiple'
			}
		}
		// const acceptFileType = (this.props.isVideoEnabled) ? 'video/*,image/*' : 'image/*';
		const acceptFileType = this.props.accept || (this.props.forVideo ? 'video/*' : 'image/*');
		if(this.props.forVideo && this.props.isJdSourceAndroid){
			addInputFileProps.capture = 'camcorder'
		}
		return (
			<div className='file-selector-div' style={{display: "none"}}>
				<input id="upload" type="file"
					accept={acceptFileType}
					onChange={(e)=> {
						this.props.onChange && this.props.onChange(e, {inputElem : this.inputElem,onFileUploadCB : this.onFileUploadCB});
					}}
					onClick={(e)=> { 
						e.stopPropagation();
						e.target.value = null;
						this.props.onClick && this.props.onClick(e);
					}}
					ref={ref => this.inputElem = ref}
					{...addInputFileProps}
				/>
			</div>
		)
	}
}

const mapStateToProps = (state, props) => {
	return {
		...props,
		isJdSourceAndroid: state.session.isJdSourceAndroid,
		isVideoEnabled: state.session.isVideoEnabled
	}
}

export default connect(mapStateToProps, null, null, {forwardRef: true})(FileSelector);
